import PropTypes from 'prop-types';
import React from 'react';

import MessageText from '../MessageText';
import './MessageAccreditationClose.style.scss';

export const MessageAccreditationClose = (props) => {
  const accreditationClosePage = () => {
    window.location.assign('/');
  };

  return (
    <>
      <MessageText
        id={props.question.id}
        text={props.question.text}
        html_id="message-accreditation-close"
        data-testid="message-accreditation-close"
        data-aut-test="message-accreditation-close"
      />

      <div className="message-line" id="container-btn-accreditation-close">
        <div
          className="message-box-close-options-save"
          id="msg-btn-accreditation-close"
        >
          <button
            className="btn-back-home"
            type="button"
            id="btn-accreditation-close"
            data-testid="btn-accreditation-close"
            onClick={() => accreditationClosePage()}
          >
            VOLTAR PARA A HOME
          </button>
        </div>
      </div>
    </>
  );
};

MessageAccreditationClose.propTypes = {
  question: PropTypes.object
};
